/* eslint-disable no-unused-vars */
import React, { Suspense } from "react";
import { useToast } from "../../../context/toast-context";
import ErrorBoundary from "../../../utils/error-boundary";
import ExitFormalityView from "./exit-formality-view";
import useExitFormalityService from "./use-exit-formality-service";

const ExitFormaliti = () => {
  const { showToastMessage } = useToast();
  const {
    getInputFieldPropsFn,
    handleSubmit,
    createFormUpdateLoading,
    exitFormalityInput,
    setExitFormalityInput,
    resource,
    exitFormalityModal,
    exitFormalityModalOpen,
    exitFormalityModalClose,
    handleClickOpen,
    imployeeInfoFromDB
  } = useExitFormalityService()
  return (
    <>
      <ErrorBoundary fallback={<p>Something went wrong in Exit Formality ...</p>}>
        <Suspense fallback={<p>Loading Exit Formality...</p>}>
          <ExitFormalityView
            getInputFieldPropsFn={getInputFieldPropsFn}
            handleSubmit={handleSubmit}
            createFormUpdateLoading={createFormUpdateLoading}
            exitFormalityInput={exitFormalityInput}
            setExitFormalityInput={setExitFormalityInput}
            resource={resource}
            exitFormalityModal={exitFormalityModal}
            exitFormalityModalOpen={exitFormalityModalOpen}
            exitFormalityModalClose={exitFormalityModalClose}
            handleClickOpen={handleClickOpen}
            imployeeInfoFromDB={imployeeInfoFromDB}
          />
        </Suspense>
      </ErrorBoundary>
    </>
  );
};

export default ExitFormaliti;
